import React from 'react';
import { Link } from 'react-router-dom';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';

type InfoPageLayoutProps = {
    eyebrow: string;
    title: string;
    subtitle: string;
    children: React.ReactNode;
};

const InfoPageLayout: React.FC<InfoPageLayoutProps> = ({ eyebrow, title, subtitle, children }) => (
    <main className="info-page">
        <section className="info-page__hero">
            <div className="info-page__hero-content">
                <Link to="/" className="info-page__back">
                    <ArrowBackRoundedIcon fontSize="small" />
                    Back to home
                </Link>
                <span className="info-page__eyebrow">{eyebrow}</span>
                <h1 className="info-page__title">{title}</h1>
                <p className="info-page__subtitle">{subtitle}</p>
            </div>
        </section>
        <section className="info-page__content">{children}</section>
    </main>
);

export default InfoPageLayout;
